export default {
  props: ['model','dataSource'],
  methods: {
    getDataSourceField(value) {
      if (!this.dataSource) {
        return value
      }
      if (typeof(value) == 'string' && value.startsWith('$')) {
        return deepFind(this.dataSource, value.substring(1))
      }      
      return value
    },
    setDataSourceField(field,value) {
      if (this.dataSource) {
        let key = field
        if (typeof key == 'string' && key.startsWith('$')) {
          key = key.substring(1)
        }
        
        var paths = key.split('.')
          , current = this.dataSource
          , i = 0
          
        for (; i < paths.length - 1; ++i) {
          if (current[paths[i]] == undefined) {
            return undefined
          } else {
            current = current[paths[i]]
          }
        }
        current[paths[i]] = value
      }
    },
    evaluateExpression(value) {

      if (!value) {
        return value
      }
      let localeRegex = /\$t\((.*?)\)/gm
      // The substituted value will be contained in the result variable
      const localeresult = value.replace(localeRegex, (match, p1) => {
        return this.$t(p1) ?? match
      })
      
      if (!this.dataSource) {
        return localeresult
      }
      const regex = /\${(.*?)}/gm
      
      // The substituted value will be contained in the result variable
      const result = localeresult.replace(regex, (match, p1) => {
        return deepFind(this.dataSource, p1) ?? match
      })
      
      return result
    }
    
  }
}

function deepFind(obj, path) {
  var paths = path.split('.')
    , current = obj
    , i

  for (i = 0; i < paths.length; ++i) {
    if (current[paths[i]] == undefined) {
      return undefined
    } else {
      current = current[paths[i]]
    }
  }
  return current
}